import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=0816a087&scoped=true&"
import script from "./Order.vue?vue&type=script&lang=js&"
export * from "./Order.vue?vue&type=script&lang=js&"
import style0 from "./Order.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Order.vue?vue&type=style&index=1&id=0816a087&lang=less&scoped=scoped&"
import style2 from "./Order.vue?vue&type=style&index=2&id=0816a087&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0816a087",
  null
  
)

export default component.exports